import { ProblemAndAnswer } from '../../../sdk-voodoo/src/shared';

type ExamRequestType = 'examRequest' | 'examUnlockRequest' | 'handedInExam';

interface ExamRequestBag {
  classId: string;
  className: string;
  examType: 'FollowUp' | 'Initial';
  firstName: string;
  isFollowUp: boolean;
  lastName: string;
  studentExamId: string;
  studentInClassId: string;
  testInClassId: string;
  testName: string;
  type: ExamRequestType;
  username: string;
}

export interface ExamRequestNotification {
  payload: {
    bag: ExamRequestBag;
    type: ExamRequestType;
  };
  type: 'new:snackbar' | 'new:notification';
}

type HelpRequestedProblem = ProblemAndAnswer & {
  overrideId?: number;
};

interface BaseHandEventStatus {
  help: number;
  helpRequestedProblem?: HelpRequestedProblem;
  online: true;
  studentInClassId: string;
  type: 'HandRaised' | 'HandLowered';
}

interface HandRaisedEventStatus extends BaseHandEventStatus {
  type: 'HandRaised';
}

interface HandLoweredEventStatus extends BaseHandEventStatus {
  type: 'HandLowered';
}

export type HandEventStatus = HandRaisedEventStatus | HandLoweredEventStatus;

export interface OverrideProblemEvent {
  helpRequestedProblem: HelpRequestedProblem;
  studentInClassId: string;
  type: 'OverrideProblem';
  teacherTriggered: boolean;
}

export enum TeacherClassesEvent {
  Status = 'status',
  NewClass = 'newClass',
  RemovedClass = 'removedClass',
  PracticeLockChanged = 'practiceLockChanged',
}

export interface StatusEvent {
  event: TeacherClassesEvent.Status;
  status: HandEventStatus | OverrideProblemEvent;
}

interface NewClassEvent {
  event: TeacherClassesEvent.NewClass;
}

interface RemovedClassEvent {
  event: TeacherClassesEvent.RemovedClass;
}

interface PracticeLockChangedEvent {
  event: TeacherClassesEvent.PracticeLockChanged;
  payload: {
    classId: string;
    manualPracticeLocked: boolean;
  };
}

export type RosteringEvent = NewClassEvent | RemovedClassEvent;

export type TeacherClassesMessage =
  | StatusEvent
  | RosteringEvent
  | PracticeLockChangedEvent
  | ExamRequestNotification;
